export default __webpack_public_path__ + "static/media/ellipsis.9ebccea4.svg";